import PropTypes from 'prop-types';
import { Drawer, Box, IconButton } from '@mui/material';
import Iconify from '../Iconify';
import { MOTION } from '../../theme/motion';

// SheetFrame — mobile bottom-sheet primitive.
// Sibling: ModalFrame (desktop centered dialog).
//
// Responsive: Pattern 3 (sibling components). This one is phone chrome.

export default function SheetFrame({ open, onClose, children, dismissible, sx, PaperProps }) {
  const paperPropsBase = {
    sx: {
      borderTopLeftRadius: '16px',
      borderTopRightRadius: '16px',
      // dvh, not vh: 90vh resolves against the LARGEST viewport, so with the
      // mobile-Safari URL bar shown the sheet's bottom ~10% sat below the
      // fold. Safe-area padding keeps the last row above the home indicator.
      maxHeight: '90dvh',
      paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      ...sx,
    },
  };
  const mergedPaperProps = PaperProps
    ? { ...paperPropsBase, ...PaperProps, sx: { ...paperPropsBase.sx, ...(PaperProps.sx || {}) } }
    : paperPropsBase;

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={dismissible ? onClose : undefined}
      transitionDuration={parseInt(MOTION.STANDARD, 10)}
      PaperProps={mergedPaperProps}
    >
      {dismissible && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1, pt: 1 }}>
          <IconButton aria-label="Close" onClick={onClose} size="small">
            <Iconify icon="eva:close-outline" />
          </IconButton>
        </Box>
      )}
      <Box sx={{ px: 2, pb: 2, overflowY: 'auto' }}>{children}</Box>
    </Drawer>
  );
}

SheetFrame.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  dismissible: PropTypes.bool,
  sx: PropTypes.object,
  PaperProps: PropTypes.object,
};

SheetFrame.defaultProps = {
  children: undefined,
  dismissible: true,
  sx: undefined,
  PaperProps: undefined,
};
